import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TenantSelector from './TenantSelector';
import { useAuthStore } from '@/stores/authStore';

const Layout: React.FC = () => {
  const { isOrgHead } = useAuthStore();
  
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <Sidebar />
      <main className="flex-1 overflow-auto flex flex-col">
        {/* Top Bar with Tenant Selector for ORG_HEAD */}
        {isOrgHead() && (
          <div className="bg-white border-b border-gray-200 px-6 py-4 flex justify-end items-center shadow-sm min-h-[70px]">
            <TenantSelector />
          </div>
        )}
        
        {/* Main Content */}
        <div className="flex-1">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;